import { useTranslation } from "react-i18next";
import { Badge } from "../../components/ui/badge";
import { formatDateTime } from "../../lib/format";
import type { OperationsLogType } from "./api";
import { OPERATIONS_LOG_TYPE_LABEL_KEY } from "./entry";

/** The entry type as a calm badge - the label always shows, never colour alone. */
export function OperationsLogTypeBadge({ type }: { type: OperationsLogType }): JSX.Element {
  const { t } = useTranslation();
  return (
    <Badge variant="outline" className="whitespace-nowrap font-medium">
      {t(OPERATIONS_LOG_TYPE_LABEL_KEY[type])}
    </Badge>
  );
}

/** "Zeitpunkt (oder Zeitraum)" ([F-015]): the start, or start to end. */
export function OperationsLogPeriod({ startAt, endAt }: { startAt: string; endAt: string | null }): JSX.Element {
  const { t } = useTranslation();
  return (
    <>
      {endAt
        ? t("operationsLog.period", { start: formatDateTime(startAt), end: formatDateTime(endAt) })
        : formatDateTime(startAt)}
    </>
  );
}
